import React from "react";
import IconSlide from '../../assets/images/icon/sliding-text-icon-1.png';

const SlidingTextOne = () => {
  const slidingTextItems = [
    { title: "Balkonrenovatie", hoverText: "Balkonrenovatie" },
    { title: "Galerijvloeren", hoverText: "Galerijvloeren", border: true },
    { title: "Betonherstel", hoverText: "Betonherstel" },
    { title: "Antislip & slijtlagen", hoverText: "Antislip & slijtlagen", border: true },
    { title: "Soprema ALSAN® PMMA", hoverText: "Soprema ALSAN® PMMA" },
    { title: "Bewonerscommunicatie", hoverText: "Bewonerscommunicatie", border: true },
  ];

  return (
    <section className="sliding-text-one">
      <div className="sliding-text-one__wrap">
        <ul className="sliding-text__list list-unstyled marquee_mode">
          {slidingTextItems.map((item, index) => (
            <li key={index}>
              <h2
                data-hover={item.hoverText}
                className={`sliding-text__title ${item.border ? "sliding-text__title-bdr" : ""}`}
              >
                {item.title}
                <img src={IconSlide} alt="" />
              </h2>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default SlidingTextOne;
